import React, { ReactElement } from 'react';
import { Box } from '@material-ui/core';
import { Body1 } from '../../atoms';

import './page-footer.styles.scss';
import { useTranslation } from 'react-i18next';

export function PageFooter(): ReactElement {
	const { t } = useTranslation('general');
	return (
		<Box
			className="page-footer"
			display="flex"
			justifyContent="center"
			padding="1.6rem"
		>
			<Body1>
				&copy;{' '}
				{t('noordHoffFooter', { year: new Date().getFullYear() })}
			</Body1>
		</Box>
	);
}
